import React from 'react'

const MiddleSection = () => {
  return (
    <div>
      
    </div>
  )
}

export default MiddleSection
